import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { Close, Info, VFlex, cn, useFlag } from '@/package';

import useVersionChecker from './useVersionChecker';

const TEMP_VToast = ({
  children,
  visible,
  autoHideDuration,

  onClose,
}: React.PropsWithChildren<{
  autoHideDuration?: number;
  visible: boolean;
  onClose: () => void;
}>) => {
  useEffect(() => {
    if (!visible || autoHideDuration == null) return;

    setTimeout(() => {
      onClose();
    }, autoHideDuration);
  }, [visible]);

  return visible
    ? createPortal(
        <VFlex
          className={cn(
            'px-4 py-2',
            'fixed top-16 right-8',
            'bg-Primary-Navy-Active',
            'text-body-lg',
            'text-black/85',
            'rounded-md',
            'z-[100]',
            'shadow-sm',
          )}
          gap={0.5}
          items="center"
        >
          <Info className="size-4 text-info-500" />
          {children}
          <Close
            role="button"
            className="size-4 text-gray-400"
            onClick={onClose}
          />
        </VFlex>,
        document.body,
      )
    : null;
};

const VersionCheckerProvider = ({ children }: PropsWithChildren) => {
  const { hasNewVersion } = useVersionChecker();
  const {
    value: visible,
    setFalse: close,
    setTrue: open,
  } = useFlag(hasNewVersion);

  useEffect(() => {
    hasNewVersion ? open() : close();
  }, [hasNewVersion]);

  return (
    <>
      {children}
      <TEMP_VToast
        autoHideDuration={2000}
        visible={visible}
        onClose={() => close()}
      >
        <div>새로운 버전이 배포 되었습니다. 새로고침을 해주세요</div>
      </TEMP_VToast>
    </>
  );
};

export default VersionCheckerProvider;
